import { ITimeDataItem } from './algoInterface'
import { classifyHourMonth } from './classifyTimeData'
import { calMeanMidMode } from './smp'

/**
 * 발전/부하 데이터 로 월별 대표패턴 구하기
 * @param {ITimeDataItem[]} data - Time 데이터 (발전/부하)
 * @returns {ITimeDataItem[]}
 */
export const calMonthRepPattern = (
  data: ITimeDataItem[],
  opt: string
): { repData: ITimeDataItem[]; graphData: any } => {
  const monthRep = {
    1: Array(24).fill(0),
    2: Array(24).fill(0),
    3: Array(24).fill(0),
    4: Array(24).fill(0),
    5: Array(24).fill(0),
    6: Array(24).fill(0),
    7: Array(24).fill(0),
    8: Array(24).fill(0),
    9: Array(24).fill(0),
    10: Array(24).fill(0),
    11: Array(24).fill(0),
    12: Array(24).fill(0),
  }
  let timeData: ITimeDataItem[] = classifyHourMonth(data)

  for (let month = 1; month < 13; month++) {
    for (let hour = 0; hour < 24; hour++) {
      const filteredSMP = timeData.filter(
        (v) => v.hour === hour && v.month === month
      )

      const hourList: number[] = filteredSMP
        .map((item) => item.value)
        .filter((value) => value !== undefined)

      const meanMidMode = calMeanMidMode(hourList)

      if (opt === 'aver') {
        timeData
          .filter((item) => item.hour === hour && item.month === month)
          .forEach((item) => {
            item.value = Number(meanMidMode.mean) ? Number(meanMidMode.mean) : 0
          })
        //@ts-ignore
        monthRep[month][hour] = Number(meanMidMode.mean)
          ? Number(meanMidMode.mean)
          : 0
      } else if (opt === 'mid') {
        timeData
          .filter((item) => item.hour === hour && item.month === month)
          .forEach((item) => {
            item.value = Number(meanMidMode.mid) ? Number(meanMidMode.mid) : 0
          })
        //@ts-ignore
        monthRep[month][hour] = Number(meanMidMode.mid)
          ? Number(meanMidMode.mid)
          : 0
      } else if (opt === 'mode') {
        timeData
          .filter((item) => item.hour === hour && item.month === month)
          .forEach((item) => {
            item.value = Number(meanMidMode.mode) ? Number(meanMidMode.mode) : 0
          })
        //@ts-ignore
        monthRep[month][hour] = Number(meanMidMode.mode)
          ? Number(meanMidMode.mode)
          : 0
      }
    }
  }
  return { repData: timeData, graphData: monthRep }
}
